import _ from 'lodash'
import store from '../store/'
import responsive from '../store/responsive'

const toggleClass = (el, binding) => {
  const queryToSmall = responsive.state['breakpoints']['to-small']
  const is360 = binding.target.closest('.product-media__orbitvu-viewer')

  if (queryToSmall || is360) {
    return
  }

  const container = document.querySelector('.product-details__top')

  if (container !== undefined) {
    // if (!store.getters['ui/isLargeMedia']) {
    //   const newImageHeight = (window.innerHeight -
    //      _.get(document.querySelector('header'), 'clientHeight', 0) -
    //      _.get(document.querySelector('.header-top__container'), 'clientHeight', 0)) // window.innerHeight - (productMedia.offsetTop + (productMediaThumbs.clientWidth * 2))

    //   store.dispatch('ui/setLargeMediaSize', newImageHeight < 740 ? newImageHeight : 740)
    // }

    container.classList.toggle('product-details__top--large-media')
    store.dispatch('ui/toggleValue', { key: 'isLargeMedia' })
  }
}

const directive = {
  bind(el) {
    if (el !== undefined) {
      el.addEventListener('click', _.partial(toggleClass, el))
    }
  },
  unbind(el) {
    el.addEventListener('click', _.partial(toggleClass, el))
  }
}

export default directive
